import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDove } from '@fortawesome/pro-light-svg-icons';
import { COLORS } from 'shared/design-system/settings/variables/Colors';

const flyAcross = keyframes`
  0% { transform: translateX(-10vw) translateY(0); opacity: 0; }
  10% { opacity: 1; }
  50% { transform: translateX(50vw) translateY(-12px); }
  90% { opacity: 1; }
  100% { transform: translateX(110vw) translateY(0); opacity: 0; }
`;

const flap = keyframes`
  0%, 100% { transform: scaleY(1); }
  50% { transform: scaleY(0.75); }
`;

const DoveLayer = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 1;
`;

const Dove = styled.div<{
  $top: number;
  $duration: number;
  $delay: number;
  $size: number;
}>`
  position: absolute;
  top: ${p => p.$top}%;
  left: 0;
  font-size: ${p => p.$size}px;
  color: ${COLORS.ctaPrimary};
  opacity: 0;
  animation: ${flyAcross} ${p => p.$duration}s linear ${p => p.$delay}s infinite;
  will-change: transform, opacity;

  svg {
    animation: ${flap} 0.4s ease-in-out infinite;
    transform-origin: center;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.12));
  }

  .letter {
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, 0);
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: ${COLORS.ctaPrimary};
    opacity: 0.2;
    pointer-events: none;
    user-select: none;
  }
`;

const DOVES: Array<{
  top: number;
  duration: number;
  delay: number;
  size: number;
  letter?: string;
}> = [
  { top: 12, duration: 7, delay: 0, size: 42, letter: 'D' },
  { top: 28, duration: 9, delay: 1.5, size: 30 },
  { top: 55, duration: 8, delay: 3, size: 38, letter: 'S' },
  { top: 72, duration: 10, delay: 0.8, size: 26, letter: 'I' },
  { top: 40, duration: 11, delay: 4.5, size: 34 },
  { top: 20, duration: 12, delay: 6, size: 28, letter: 'A' },
  { top: 62, duration: 9, delay: 5.2, size: 32, letter: 'E' },
  { top: 48, duration: 10, delay: 2.2, size: 24 },
];

const DoveAnimation: React.FC = () => (
  <DoveLayer aria-hidden="true">
    {DOVES.map((d, i) => (
      <Dove
        key={i}
        $top={d.top}
        $duration={d.duration}
        $delay={d.delay}
        $size={d.size}
      >
        <FontAwesomeIcon icon={faDove} />
        {d.letter && <span className="letter">{d.letter}</span>}
      </Dove>
    ))}
  </DoveLayer>
);

export default DoveAnimation;
